import React from 'react';
import { 
  Box, 
  Typography, 
  Chip, 
  Tooltip, 
  IconButton 
} from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

/**
 * ProjectTypeTooltip component that displays detailed information about project types
 * @param {Object} projectType - The project type object with value, label, description, and characteristics
 * @param {string} placement - Tooltip placement (default: 'right')
 */
const ProjectTypeTooltip = ({ projectType, placement = 'right' }) => {
  const tooltipContent = (
    <Box sx={{ maxWidth: 300 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
        {projectType.label}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {projectType.description}
      </Typography>
      <Typography variant="caption" sx={{ mb: 1, display: 'block', fontWeight: 'bold' }}>
        Key Characteristics:
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {projectType.characteristics.map((characteristic, index) => (
          <Chip 
            key={index} 
            label={characteristic} 
            size="small" 
            variant="outlined"
            sx={{ 
              fontSize: '0.7rem',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              color: 'inherit'
            }}
          />
        ))}
      </Box>
    </Box>
  );

  return (
    <Tooltip 
      title={tooltipContent}
      arrow
      placement={placement}
      enterDelay={300}
      leaveDelay={200}
    >
      <IconButton size="small" sx={{ ml: 1 }}>
        <InfoIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default ProjectTypeTooltip;